import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import InteractiveReadingComp from "../components/InteractiveReadingComp";

export default function InteractiveReadingPage() {
  return (
    <>
      <Navbar />
      <InteractiveReadingComp />
      <Footer />
    </>
  );
}
